export default {
  heading: {
    widgetName: "Little-Ones-Pack",
    widgetID: "107",
    widgetWidth: "3",
    cardCount: "4",
    layoutName: "lob_widget",
    headline: "From baby food to teething snacks, your little ones will surely love it!",
    headlineType: 'h2',
    subHeadline: "",
    showMoreURL: "",
    gtmParameters: {
      event: "trackEventNoEcommerce",
      eventActionClick: "click",
      eventActionView: "view",
      eventCategory: `Grocer Campaign | Grocer Value Pack`,
      eventLabelCardClick: `Grocer Value Pack | {{cardtitle}} | {{cardwidth}} | {{cardposition}} | {{redirecturl}}`,
      eventLabelHeadlineClick: `Grocer Value Pack | headline | {{headline}}`,
      eventLabelView: `Grocer Value Pack`,
    },
  },

  data: [
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/value-pack/teething-baby-organic-value-pack.jpg",
      title: "Teething Baby Organic Value Pack",
      subtitle: "Suitable for 6 - 12 months old",
      star: "",
      originalprice: "44.60",
      price: "39",
      cta: "Buy Now",
      url: "https://www.airasia.com/grocer/my/en/product/bio-lifestyle/teething-baby-organic-value-pack",
      currencyCode: "MYR",
    },
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/value-pack/toddler-gluten-free-and-organic-value-pack.jpg",
      title: "Toddler Gluten Free and Organic Value Pack",
      subtitle: "Suitable 12 months+ old",
      star: "",
      originalprice: "47.90",
      price: "43.00",
      cta: "Buy Now",
      url: "https://www.airasia.com/grocer/my/en/product/bio-lifestyle/toddler-gluten-free-and-organic-value-pack",
      currencyCode: "MYR",
    },
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/value-pack/purply-baby-foods-value-pack.jpg",
      title: "Purply Baby Foods Organic Value Pack",
      subtitle: "Suitable for 6 - 9 months old",
      star: "",
      originalprice: "51.70",
      price: "45.00",
      cta: "Buy Now",
      url: "https://www.airasia.com/grocer/my/en/product/bio-lifestyle/purply-baby-foods-organic-value-pack",
      currencyCode: "MYR",
    },
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/value-pack/yellow-mellow-organic-value-pack.jpg",
      title: "Yellow Mellow Organic Value Pack",
      subtitle: "Suitable for 6 - 9 months old",
      star: "",
      originalprice: "68.60",
      price: "59.90",
      cta: "Buy Now",
      url: "https://www.airasia.com/grocer/my/en/product/bio-lifestyle/yellow-mellow-organic-value-pack",
      currencyCode: "MYR",
    },
  ],
}
